import React, { ComponentType } from "react";
import { lazy } from "react";

export const lazyWithRetry = (
  componentImport: () => Promise<{ default: ComponentType<any> }>,
  retriesLeft = 2,
  interval = 1000
): any => {
  return lazy(() => {
    return new Promise<{ default: ComponentType<any> }>((resolve) => {
      const executeImport = (attempts: number) => {
        componentImport()
          .then(resolve)
          .catch((error) => {
            if (attempts > 0) {
              setTimeout(() => {
                executeImport(attempts - 1);
              }, interval);
            } else {
              console.error("Chunk loading failed after retries:", error);
              // Resolve with the fallback connection lost component
              resolve({
                default: () => (
                  <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center bg-vintageBg font-gilroyRegular text-vintageText">
                    <div className="bg-vintageText/10 p-6 rounded-full mb-6 font-semibold">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-16 h-16 text-vintageText"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={1.5}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                    </div>
                    <h2 className="text-2xl font-bold mb-3 tracking-wider font-melodramaRegular">
                      Connection Lost
                    </h2>
                    <p className="text-gray-600 mb-8 max-w-md">
                      We couldn't load this page because you are offline. Please check your internet connection and try again.
                    </p>
                    <button
                      onClick={() => window.location.reload()}
                      className="px-6 py-2.5 bg-vintageText text-vintageBg rounded-xl font-semibold tracking-wider hover:bg-opacity-90 transition shadow-md"
                    >
                      Retry
                    </button>
                  </div>
                ),
              });
            }
          });
      };

      executeImport(retriesLeft);
    });
  });
};
